import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/app/services/ecommerce/advance-feature.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/cards/testimonial/rating/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/workspace/src/components/carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabSection"] */ "/workspace/src/components/tab-section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/workspace/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkflowSection"] */ "/workspace/src/components/workflow-section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/workspace/src/sections/hero/v5/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectSectionV4"] */ "/workspace/src/sections/project/v4/index.tsx");
